module.exports = __webpack_public_path__ + "static/media/delivery_spreadsheet_blur.4350e884.png";